import { isEmpty } from 'lodash'

const INITIAL_VALUES = {
  imageData: {},
  leftGroup: {},
  rightGroup: {},
  metrics: [],
  metrics2: [],
}

export const getProperties = (data) => {
  if (isEmpty(data)) return INITIAL_VALUES

  const imageData = data?.image_data

  const leftGroup = data?.content?.left_group
  const rightGroup = data?.content?.right_group

  const metrics = leftGroup?.metrics_left
  const metrics2 = rightGroup?.metrics_right

  return {
    imageData,
    leftGroup,
    rightGroup,
    metrics,
    metrics2,
  }
}
